export default __webpack_public_path__ + "files/thumbnail-e6258a07d2230ab02eccf6fb68c18e26.png";